// extracted by mini-css-extract-plugin
module.exports = {"switch":"index_switch__6n9mY","switch_btn":"index_switch_btn__AyOVT","disabled":"index_disabled__F2prV","icon":"index_icon__T_Hng","left":"index_left__bFttB"};